import { handleActions } from 'redux-actions';

import { closeAlert, setExecuted, showAlert } from 'redux/actions/alertActions';
import { ALERT_TYPE_SUCCESS } from 'shared/utils';

const defaultState = {
  openAlert: false,
  alertType: ALERT_TYPE_SUCCESS,
  alertMessage: '',
  executeActionCloseAlert: false,
};

export default handleActions(
  {
    [showAlert](state, action) {
      const { alertType, alertMessage } = action.payload;
      return { ...state, alertType, alertMessage, openAlert: true, executeActionCloseAlert: false };
    },
    [closeAlert](state) {
      return { ...state, openAlert: false, alertMessage: '', executeActionCloseAlert: true };
    },
    [setExecuted](state) {
      return { ...state, executeActionCloseAlert: false };
    },
  },
  defaultState
);
